import { makeAutoObservable, action, toJS, runInAction } from "mobx";
import { compare, applyPatch } from "fast-json-patch";
class CreationScriptStores {
  dataSource = [];
  wsUuid = null
  constructor() {
    makeAutoObservable(this);
  }

  updateData = action((index, type, value) => {
    const newData = [...this.dataSource];
    newData[index][type] = value;
    this.dataSource = newData;
  });

  changeCaption = action((index, type, value) => {
    const newData = [...this.dataSource];
    newData[index][type] = value;
    this.dataSource = newData;
  });
  addCaptions = action((key) => {
    const newData = [...this.dataSource];
    newData.forEach((item) => {
      item[`caption_${key}`] = [
        {
          type: "listItem",
          content: [
            {
              type: "paragraph",
            },
          ],
        },
      ];
    });
    this.dataSource = newData;
  });
  delData = action((newData) => {
    this.dataSource = JSON.parse(JSON.stringify(newData));
  });
  compareUpdate = action((newData) => {
    runInAction(() => {
      const patch = compare(this.dataSource, newData);
      applyPatch(this.dataSource, patch);
    });
  });
  setUuid = action((uuid) => {
    this.wsUuid = uuid;
  });
}

const creationStores = new CreationScriptStores();
export default creationStores;
